import * as dayjs from 'dayjs'
import { mapCaretakerQualification } from '../../nursingHome.mapper'
import { AccompanimentsBookedService } from '../accompaniments.model'
import { AccompanimentsSearchServiceDto } from '../accompanimentsSearch/accompanimentsSearch.model'
import { AccompanimentsBookedServiceDto } from './accompanimentsBookedServices.model'

const checkIfServiceIsOnGoing = (schedule: AccompanimentsSearchServiceDto['serviceSchedule']): boolean => {
  const now = dayjs()
  const startTime = dayjs(schedule[0].start)
  const endTime = dayjs(schedule[schedule.length - 1].end)

  return now.isAfter(startTime) && now.isBefore(endTime)
}

export const mapAccompanimentsBookedServiceList = (
  serviceListDto: AccompanimentsBookedServiceDto[],
): AccompanimentsBookedService[] => {
  return serviceListDto.map(serviceDto => ({
    serviceRef: serviceDto.serviceId,
    caredPerson: serviceDto.resident,
    dates: serviceDto.serviceSchedule.map(interval => ({
      startTime: dayjs(interval.start).toDate(),
      endTime: dayjs(interval.end).toDate(),
    })),
    duration: serviceDto.estimatedDuration,
    address: serviceDto.location,
    handler: serviceDto.requestedByInstitutionManager,
    job: serviceDto.additionalInfo,
    isOngoing: checkIfServiceIsOnGoing(serviceDto.serviceSchedule),
    caretaker: {
      id: serviceDto.reservedRequest.caretakerId,
      userId: serviceDto.reservedRequest.caretakerUserId,
      requestId: serviceDto.reservedRequest.requestId,
      name: serviceDto.reservedRequest.caretakerName,
      image: serviceDto.reservedRequest.caretakerProfileImage,
      phone: serviceDto.reservedRequest.caretakerTelephone,
      email: serviceDto.reservedRequest.caretakerEmail,
      qualification: mapCaretakerQualification(serviceDto.reservedRequest.mainQualification),
      hourlyWage: serviceDto.reservedRequest.caretakerHourlyRate / 100,
      totalWage: serviceDto.reservedRequest.budget / 100,
    },
  }))
}



// WEBPACK FOOTER //
// ./src/domain/model/nursingHome/accompaniments/accompanimentsBookedServices/accompanimentsBookedServices.mapper.ts